export interface Warning {
    property: string
    message: string
}